import { render, staticRenderFns } from "./InterestUpdate.vue?vue&type=template&id=724be019&"
import script from "./InterestUpdate.vue?vue&type=script&lang=js&"
export * from "./InterestUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports